import React, { useEffect, useState } from "react";

const SearchableMultiSelect = (props) => {
    const { lstItems, lstSelected, handleSelectId, valueField, labelField, labelName } = props;

    const [searchTerm, setSearchTerm] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [lstSelect, setLstSelect] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [lstSelectLabel, setLstSelectLabel] = useState([]);

    // Initialize filtered items and selected items
    useEffect(() => {
        // console.log("SearchableMultiSelect called, lstItems", lstItems, ", lstSelected", lstSelected);
        setFilteredItems(lstItems);
    }, [lstItems]);

    useEffect(() => {
        // console.log("SearchableMultiSelect called lstSelected", lstSelected);
        if (lstSelected && lstSelected.length) {
            setLstSelect(lstSelected);
            setLstSelectLabel(getLabelsFromIds(lstSelected));
        } else {
            setLstSelectLabel([]);
            setLstSelect([]);
        }
    }, [lstSelected]);

    // Filter the items based on the search term
    const filterItems = (pSearchTerm) => {
        setSearchTerm(pSearchTerm);
        const updatedLstTerm = lstItems.filter((item) =>
            item[labelField]?.toLowerCase().includes(pSearchTerm.toLowerCase())
        );
        setFilteredItems(updatedLstTerm);
    };

    // Handle checkbox selection
    const toggleSelect = (itemValue) => {
        // console.log("toggleSelect called, itemValue", itemValue);
        let updatedLstSelect;
        if (lstSelect.includes(itemValue)) {
            // If the item is already selected, remove it
            updatedLstSelect = lstSelect.filter((value) => value !== itemValue);
        } else {
            // If the item is not selected, add it
            updatedLstSelect = [...lstSelect, parseInt(itemValue)];
        }

        setLstSelectLabel(getLabelsFromIds(updatedLstSelect));
        setLstSelect(updatedLstSelect); // Update local state
        handleSelectId(updatedLstSelect); // Pass the updated selection to the parent
    };


    const getLabelsFromIds = (idArray) => {
        // console.log("getLabelsFromIds called, idArray", idArray);
        return idArray.map(id => {
            const found = lstItems.find(obj => obj[valueField] == id);
            // console.log("found", found);
            return found ? found.interest : null;
        });
    };

    return (
        <div style={{ position: "relative", width: "100%" }}>
            <div
                style={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "8px",
                    cursor: "pointer",
                    backgroundColor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
                onClick={() => setDropdownOpen(!dropdownOpen)}
            >
                <span>
                    {
                        dropdownOpen ? (
                            <input
                                type="text"
                                placeholder={`Search ${labelName}`}
                                value={searchTerm}
                                onChange={(e) => filterItems(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "2px",
                                    border: "none",
                                    borderBottom: "1px solid #ccc",
                                    boxSizing: "border-box",
                                    outline: "none",
                                }}
                                onClick={(e) => e.stopPropagation()}
                            />
                        ) : null
                    }
                    { lstSelectLabel && lstSelectLabel.length ?
                        lstSelectLabel.map((item, index) => (
                            <span key={index} style={{ display: "inline-block", padding: "2px 6px", border: "1px solid #ccc", borderRadius: "10px", marginRight: "5px" }}>
                                {item}
                            </span>
                        ))
                        : 
                            <span  style={{ color:"#999", marginRight: "5px" }}>
                                Please select your interests
                            </span>
                    }
                </span>
                <span
                    className={dropdownOpen ? "glyphicon glyphicon-menu-up" : "glyphicon glyphicon-menu-down"}
                    title="Select items"
                    style={{
                        cursor: "pointer",
                    }}
                ></span>
            </div>

            {dropdownOpen && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        width: "100%",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                        maxHeight: "150px",
                        overflowY: "auto",
                        zIndex: 10,
                    }}
                >
                    {filteredItems.map((item) => (
                        <label
                            key={item[valueField]}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px",
                                cursor: "pointer",
                                fontWeight: "normal",
                            }}
                        >
                            <input
                                type="checkbox"
                                value={parseInt(item[valueField])}
                                checked={lstSelect.includes(parseInt(item[valueField]))}
                                onChange={() => toggleSelect(parseInt(item[valueField]))}
                                style={{ marginRight: "8px" }}
                            />
                            {item[labelField]}
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SearchableMultiSelect;
